// Translated API errors for the composer and Home (decision D36.4): the server's message is English by design (logs,
// API clients); what a person reads is the i18n text of the refusal's `details.cause` when known, else of its error
// code. The server message stays available as a technical detail (with the correlation id the banners already show).
import { isApiError } from "../api/client.ts";
import { en, type MessageKey } from "../i18n/en.ts";
import type { Translate } from "../i18n/index.tsx";

export interface ApiErrorView {
  /** What the person reads, in the UI language. */
  message: string;
  /** The server's own message, when it says more than the translation (English; shown as a technical detail). */
  detail: string | null;
}

const key = (k: string): MessageKey | null => (k in en ? (k as MessageKey) : null);

/** The translated message of any error a composer or Home request can raise. */
export function apiErrorView(error: unknown, t: Translate): ApiErrorView {
  if (!isApiError(error)) {
    if (error instanceof DOMException && error.name === "AbortError") return { message: t("apiError.code.unknown"), detail: null };
    return { message: t("error.generic"), detail: error instanceof Error && error.message ? error.message : null };
  }
  if (error.code === "network") return { message: t(error.details?.["upload"] === true ? "error.uploadInterrupted" : "error.network"), detail: null };
  const detail = error.message && error.message.trim() ? error.message : null;
  const cause = typeof error.details?.["cause"] === "string" ? (error.details["cause"] as string) : null;
  const byCause = cause ? key(`apiError.cause.${cause}`) : null;
  if (byCause) return { message: t(byCause), detail };
  if (error.status === 413) return { message: t("apiError.tooLarge"), detail };
  const byCode = key(`apiError.code.${error.code}`);
  return { message: t(byCode ?? "apiError.code.unknown"), detail };
}
